import { actionTypes, initialState } from '!/common/constants';
import { widgets } from '!/config/widgets';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_STORE:
      return {
        ...state,
        ...action.state
      };

    case actionTypes.UPDATE_SETTINGS:
      return {
        ...state,
        settings: { ...state.settings, ...action.settings }
      };

    case actionTypes.UPDATE_STATUS:
      return {
        ...state,
        status: action.status
      };

    case actionTypes.CLEAR_FILTERS:
      if (action.clear) return { ...state, applied: [], values: {} };
      break;

    case actionTypes.UPDATE_FILTER:
      const { name, value } = action;
      let { values, page } = state;

      const maxValue = widgets
        .find(item => item.name === 'price_range')
        .options.ranges.slice(-1)
        .pop().from;

      const applied = [...state.applied];
      const index = applied.indexOf(name);

      if (index > -1 && !value.length) {
        applied.splice(index, 1);
      } else if (index === -1) {
        applied.push(name);
      }

      values = { ...values, [name]: value };

      // resetting page
      page = 1;

      return { ...state, applied, values, page };

    case actionTypes.UPDATE_RESULTS:
      return {
        ...state,
        hits: action.results.hits,
        aggs: action.results.aggs,
        total: action.results.total
      };

    case actionTypes.UPDATE_SORT:
      return {
        ...state,
        values: Object.assign({}, { ...state.values }, { sort: action.value })
      };

    case actionTypes.UPDATE_PAGE:
      return {
        ...state,
        page: action.page
      };

    default:
      return state;
  }
};
